import React, { createContext, useState, useContext } from 'react';

const SharedContext = createContext();

export const useSharedState = () => {
    return useContext(SharedContext);
};

export const SharedStateProvider = ({ children }) => {
    const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split('T')[0]);

    const value = {
        selectedDate,
        setSelectedDate,
    };

    return (
        <SharedContext.Provider value={value}>
            {children}
        </SharedContext.Provider>
    );
};
